import { useQuery } from "@vue/apollo-composable";
import { DEFAULT_CART_NAME } from "@/core/api/graphql/cart/queries/getFullCart";
import { GetShortCartDocument } from "@/core/api/graphql/types";
import { globals } from "@/core/globals";

export function useGetShortCartQuery() {
  const { storeId, cultureName, currencyCode, userId } = globals;
  return useQuery(
    GetShortCartDocument,
    {
      storeId,
      cultureName,
      currencyCode,
      userId,
      cartName: DEFAULT_CART_NAME,
    },
    {
      notifyOnNetworkStatusChange: true,
    },
  );
}
